const Step = function(arr, firstElement, secondElement, status) {
  this.arr = arr;
  this.firstElement = firstElement;
  this.secondElement = secondElement;
  this.status = status
}

export default Step
